import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.353 6.85a1.69 1.69 0 1 0 0 3.38 1.69 1.69 0 0 0 0-3.38m10.393-3.1H5.223C4.009 3.75 3 4.759 3 6.004v11.27c0 1.245 1.009 2.254 2.222 2.254h13.524A2.254 2.254 0 0 0 21 17.274V6.004a2.234 2.234 0 0 0-2.254-2.254m.564 13.288-4.818-6.547c-.088-.162-.289-.26-.504-.26a.66.66 0 0 0-.535.259l-3.755 5.075-1.306-1.624a.67.67 0 0 0-.52-.24.67.67 0 0 0-.52.24l-2.66 3.304L4.69 6.004c0-.31.253-.564.564-.564h13.524c.31 0 .563.253.563.564v11.034z"
    }, null, -1)
  ]))]))
}
export default { render: render }